import CheckWithCircle from "@assets/icons/check-with-circle.svg";
import Dashed from "@assets/icons/no-program-assigned.svg";
import PlayWithCircle from "@assets/icons/play.svg";
import Warn from "@assets/icons/program-status-warn.svg";
import { GlobalProgramStatusType } from "@domain/program/program-status/program-status";
import styled from "@emotion/styled";
import { colors } from "@ui/style/colors";
import React from "react";

export type ProgramStatusRenderProps =
	| {
			type:
				| GlobalProgramStatusType.ScheduledProgram
				| GlobalProgramStatusType.EndedLastProgramDetailsMode
				| GlobalProgramStatusType.NoProgram;
			label: string;
	  }
	| { type: GlobalProgramStatusType.EndedLastProgram; label: string; labelColor: string }
	| {
			type: GlobalProgramStatusType.OngoingProgram | GlobalProgramStatusType.EndingSoonProgramWithNoNext;
			pieChartProgressPercentage: number;
			pieChartColor: string;
			label: string;
	  };

export const ProgramStatusIcon: React.FC<{ props: ProgramStatusRenderProps }> = ({ props }) => {
	switch (props.type) {
		case GlobalProgramStatusType.ScheduledProgram:
			return <PlayWithCircleIcon />;
		case GlobalProgramStatusType.EndedLastProgram:
			return <DangerIcon />;
		case GlobalProgramStatusType.EndedLastProgramDetailsMode:
			return <CheckWithCircleIcon />;
		case GlobalProgramStatusType.NoProgram:
			return <DashedCircle />;
		case GlobalProgramStatusType.OngoingProgram:
		case GlobalProgramStatusType.EndingSoonProgramWithNoNext:
			return (
				<CircleContainer color={props.pieChartColor}>
					<PieChart progress={360 - Math.round(360 * props.pieChartProgressPercentage)} color={props.pieChartColor} />
				</CircleContainer>
			);
	}
};

const PlayWithCircleIcon = styled(PlayWithCircle)`
	width: 16px;
	height: 16px;
	color: ${colors.grey80};
`;

const CheckWithCircleIcon = styled(CheckWithCircle)`
	width: 16px;
	height: 16px;
	color: ${colors.grey80};
`;

const DangerIcon = styled(Warn)`
	width: 16px;
	height: 16px;
	color: ${colors.rejection};
`;

const DashedCircle = styled(Dashed)`
	width: 16px;
	height: 16px;
	color: ${colors.grey80};
`;

const CircleContainer = styled.div<{ color: string }>`
	width: 16px;
	height: 16px;
	border-radius: 8px;
	border: 2px solid ${({ color }) => color};
	display: flex;
	justify-content: center;
	align-items: center;
`;

const PieChart = styled.div<{ progress: number; color: string }>`
	width: 8px;
	height: 8px;
	border-radius: 6px;
	background: conic-gradient(
		${({ progress, color }) => `${colors.white} 0deg ${progress}deg, ${color}  ${progress}deg 360deg`}
	);
`;
